/**
 * KnorShot Verkooppunten
 *
 * Kaart van Nederland met klikbare pins, gevoed door de metaobjects
 * 'verkooppunt'. Geen externe libraries, geen API-key, geen tegel-requests.
 *
 * De landsomtrek en de pins gebruiken dezelfde projectie. Daardoor kunnen ze
 * per definitie niet uit elkaar lopen: er is geen aparte kalibratie nodig
 * tussen een geimporteerde kaartafbeelding en de coordinaten.
 *
 * De lijst staat al in de HTML. Dit script leest die lijst, tekent de kaart
 * erboven en voegt filters toe. Zonder JavaScript blijft de lijst leesbaar.
 */

(function () {
  'use strict';

  var SVG_NS = 'http://www.w3.org/2000/svg';

  /**
   * Vereenvoudigde omtrek van Nederland als [lat, lng], met de klok mee vanaf
   * Den Helder. Bewust grof gehouden: op landelijk zoomniveau telt de
   * herkenbare silhouet, niet de kustlijn tot op de meter.
   */
  var OMTREK = [
    [52.96, 4.76], [52.93, 5.03], [53.06, 5.33], [53.18, 5.42], [53.30, 5.60],
    [53.35, 5.90], [53.40, 6.15], [53.44, 6.55], [53.42, 6.90], [53.32, 7.20],
    [53.10, 7.20], [52.85, 7.07], [52.64, 7.06], [52.45, 7.07], [52.22, 7.03],
    [52.12, 6.83], [51.97, 6.72], [51.87, 6.40], [51.83, 6.16], [51.75, 6.03],
    [51.64, 6.13], [51.50, 6.20], [51.37, 6.17], [51.25, 6.08], [51.17, 6.07],
    [51.05, 5.95], [50.90, 5.95], [50.75, 6.02], [50.80, 5.70], [50.95, 5.70],
    [51.05, 5.55], [51.16, 5.55], [51.26, 5.48], [51.30, 5.20], [51.42, 4.95],
    [51.42, 4.65], [51.43, 4.40], [51.37, 4.25], [51.30, 4.20], [51.25, 4.10],
    [51.22, 3.85], [51.28, 3.55], [51.32, 3.36], [51.42, 3.42], [51.55, 3.50],
    [51.65, 3.70], [51.80, 3.85], [51.98, 4.05], [52.10, 4.25], [52.25, 4.45],
    [52.40, 4.55], [52.60, 4.63], [52.80, 4.70]
  ];

  /** IJsselmeer en Markermeer als een enkel wateroppervlak. */
  var WATER = [
    [52.93, 5.04], [53.06, 5.33], [52.98, 5.42], [52.88, 5.55], [52.83, 5.72],
    [52.72, 5.78], [52.62, 5.72], [52.55, 5.58], [52.45, 5.42], [52.35, 5.25],
    [52.30, 5.12], [52.33, 5.02], [52.45, 5.04], [52.58, 5.03], [52.68, 5.04],
    [52.78, 5.02], [52.88, 5.02]
  ];

  var LAT_MAX = 53.60;
  var LAT_MIN = 50.68;
  var LNG_MIN = 3.25;
  var LNG_MAX = 7.30;
  var MID_LAT_COS = Math.cos((52.1 * Math.PI) / 180);

  var BREEDTE = 1000;
  var SCHAAL = BREEDTE / ((LNG_MAX - LNG_MIN) * MID_LAT_COS);
  var HOOGTE = Math.round((LAT_MAX - LAT_MIN) * SCHAAL);

  /** Zet een lat/lng om naar coordinaten binnen de viewBox. */
  function projecteer(lat, lng) {
    return {
      x: (lng - LNG_MIN) * MID_LAT_COS * SCHAAL,
      y: (LAT_MAX - lat) * SCHAAL
    };
  }

  function naarPad(punten) {
    var d = '';
    for (var i = 0; i < punten.length; i++) {
      var p = projecteer(punten[i][0], punten[i][1]);
      d += (i === 0 ? 'M' : 'L') + p.x.toFixed(1) + ' ' + p.y.toFixed(1);
    }
    return d + 'Z';
  }

  function maakSvgElement(naam, attrs) {
    var el = document.createElementNS(SVG_NS, naam);
    Object.keys(attrs).forEach(function (key) {
      el.setAttribute(key, attrs[key]);
    });
    return el;
  }

  /** Vier cijfers en twee letters, met of zonder spatie. Geeft '8245GH' of ''. */
  function normaliseerPostcode(waarde) {
    var m = /^\s*([1-9][0-9]{3})\s?([A-Za-z]{2})\s*$/.exec(waarde || '');
    return m ? m[1] + m[2].toUpperCase() : '';
  }

  /** Hemelsbrede afstand in kilometers (haversine). */
  function afstandKm(lat1, lng1, lat2, lng2) {
    var rad = Math.PI / 180;
    var dLat = (lat2 - lat1) * rad;
    var dLng = (lng2 - lng1) * rad;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * rad) * Math.cos(lat2 * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 6371 * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function tekstRegel(tekst, className) {
    var el = document.createElement('span');
    el.className = className;
    el.textContent = tekst;
    return el;
  }

  class KnorshotMap extends HTMLElement {
    connectedCallback() {
      this.lijst = this.querySelector('[data-list]');
      this.canvas = this.querySelector('[data-canvas]');
      this.popup = this.querySelector('[data-popup]');
      this.filterBalk = this.querySelector('[data-filters]');
      this.teller = this.querySelector('[data-count]');
      this.leeg = this.querySelector('[data-empty]');
      this.resetKnop = this.querySelector('[data-reset]');

      if (!this.lijst) return;

      this.rijen = Array.prototype.slice.call(this.lijst.querySelectorAll('[data-row], .ks-map__row'));
      if (!this.rijen.length) return;

      this.actieveFilters = { provincie: '', soort: '' };
      this.pins = [];
      this.chips = [];

      if (this.resetKnop) {
        var self = this;
        this.resetKnop.addEventListener('click', function () {
          self.actieveFilters = { provincie: '', soort: '' };
          self.chips.forEach(function (c) {
            c.el.setAttribute('aria-pressed', c.waarde === '' ? 'true' : 'false');
          });
          self.wisZoek();
          self.sluitPopup();
          self.pasFiltersToe();
        });
      }

      this.zoek = null;
      if (this.canvas) this.tekenKaart();
      this.bouwFilters();
      this.bouwZoek();
      this.pasFiltersToe();

      this.onDocumentClick = this.onDocumentClick.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      document.addEventListener('click', this.onDocumentClick);
      this.addEventListener('keydown', this.onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDocumentClick);
    }

    tekenKaart() {
      var svg = maakSvgElement('svg', {
        viewBox: '0 0 ' + BREEDTE + ' ' + HOOGTE,
        class: 'ks-map__svg',
        'aria-hidden': 'true',
        focusable: 'false'
      });

      svg.appendChild(maakSvgElement('path', { d: naarPad(OMTREK), class: 'ks-map__land' }));
      svg.appendChild(maakSvgElement('path', { d: naarPad(WATER), class: 'ks-map__water' }));

      this.canvas.insertBefore(svg, this.canvas.firstChild);

      var self = this;
      this.rijen.forEach(function (rij, index) {
        var lat = parseFloat(rij.dataset.lat);
        var lng = parseFloat(rij.dataset.lng);
        if (isNaN(lat) || isNaN(lng)) return;

        var positie = projecteer(lat, lng);
        var knop = document.createElement('button');
        knop.type = 'button';
        knop.className = 'ks-map__pin';
        knop.style.left = ((positie.x / BREEDTE) * 100).toFixed(3) + '%';
        knop.style.top = ((positie.y / HOOGTE) * 100).toFixed(3) + '%';
        knop.setAttribute('aria-label', rij.dataset.naam + ' in ' + rij.dataset.plaats);
        knop.setAttribute('aria-expanded', 'false');
        knop.dataset.index = String(index);

        knop.addEventListener('click', function (event) {
          event.stopPropagation();
          self.toonPopup(rij, knop);
        });

        self.canvas.appendChild(knop);
        self.pins.push(knop);
        rij.pinElement = knop;
      });
    }

    toonPopup(rij, knop) {
      if (!this.popup) return;

      if (this.actievePin === knop) {
        this.sluitPopup();
        return;
      }

      this.popup.textContent = '';

      var sluit = document.createElement('button');
      sluit.type = 'button';
      sluit.className = 'ks-map__popup-close';
      sluit.setAttribute('aria-label', 'Sluiten');
      sluit.textContent = '×';
      var self = this;
      sluit.addEventListener('click', function (event) {
        event.stopPropagation();
        self.sluitPopup(true);
      });
      this.popup.appendChild(sluit);

      this.popup.appendChild(tekstRegel(rij.dataset.naam, 'ks-map__popup-naam'));
      this.popup.appendChild(tekstRegel(rij.dataset.soort, 'ks-map__popup-soort'));

      var adresRegels = [];
      if (rij.dataset.adres) adresRegels.push(rij.dataset.adres);
      var plaatsRegel = [rij.dataset.postcode, rij.dataset.plaats].filter(Boolean).join(' ');
      if (plaatsRegel) adresRegels.push(plaatsRegel);
      if (adresRegels.length) {
        this.popup.appendChild(tekstRegel(adresRegels.join(', '), 'ks-map__popup-adres'));
      }

      var acties = document.createElement('div');
      acties.className = 'ks-map__popup-acties';

      var route = document.createElement('a');
      route.className = 'ks-map__popup-route';
      route.href = 'https://www.google.com/maps/search/?api=1&query=' + rij.dataset.route;
      route.target = '_blank';
      route.rel = 'noopener';
      route.textContent = 'Route';
      acties.appendChild(route);

      if (rij.dataset.website) {
        var site = document.createElement('a');
        site.className = 'ks-map__popup-site';
        site.href = rij.dataset.website;
        site.target = '_blank';
        site.rel = 'noopener';
        site.textContent = 'Website';
        acties.appendChild(site);
      }

      this.popup.appendChild(acties);

      this.popup.style.left = knop.style.left;
      this.popup.style.top = knop.style.top;
      this.popup.hidden = false;

      this.pins.forEach(function (p) {
        p.setAttribute('aria-expanded', 'false');
        p.classList.remove('is-actief');
      });
      knop.setAttribute('aria-expanded', 'true');
      knop.classList.add('is-actief');
      this.actievePin = knop;

      sluit.focus();
    }

    sluitPopup(herstelFocus) {
      if (!this.popup || this.popup.hidden) return;
      this.popup.hidden = true;
      this.popup.textContent = '';
      if (this.actievePin) {
        this.actievePin.setAttribute('aria-expanded', 'false');
        this.actievePin.classList.remove('is-actief');
        if (herstelFocus) this.actievePin.focus();
      }
      this.actievePin = null;
    }

    onDocumentClick(event) {
      if (this.popup && !this.popup.hidden && !this.popup.contains(event.target)) {
        this.sluitPopup();
      }
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        this.sluitPopup(true);
        return;
      }

      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

      var zichtbaar = this.pins.filter(function (p) {
        return !p.hidden;
      });
      var huidige = zichtbaar.indexOf(document.activeElement);
      if (huidige === -1) return;

      event.preventDefault();
      var stap = event.key === 'ArrowRight' ? 1 : -1;
      var volgende = (huidige + stap + zichtbaar.length) % zichtbaar.length;
      zichtbaar[volgende].focus();
    }

    bouwFilters() {
      if (!this.filterBalk) return;

      var provincies = [];
      var soorten = [];
      this.rijen.forEach(function (rij) {
        if (rij.dataset.provincie && provincies.indexOf(rij.dataset.provincie) === -1) {
          provincies.push(rij.dataset.provincie);
        }
        if (rij.dataset.soort && soorten.indexOf(rij.dataset.soort) === -1) {
          soorten.push(rij.dataset.soort);
        }
      });
      provincies.sort();
      soorten.sort();

      // Een filter met maar een waarde filtert niets. Dan tonen we hem niet.
      var groepen = [];
      if (provincies.length > 1) groepen.push({ sleutel: 'provincie', label: 'Provincie', waarden: provincies });
      if (soorten.length > 1) groepen.push({ sleutel: 'soort', label: 'Soort zaak', waarden: soorten });
      if (!groepen.length) return;

      var self = this;
      groepen.forEach(function (groep) {
        var wrap = document.createElement('div');
        wrap.className = 'ks-map__filter-groep';
        wrap.setAttribute('role', 'group');
        wrap.setAttribute('aria-label', groep.label);

        var kop = document.createElement('span');
        kop.className = 'ks-map__filter-label';
        kop.style.flexBasis = '100%';
        kop.textContent = groep.label;
        kop.setAttribute('aria-hidden', 'true');
        wrap.appendChild(kop);

        var alles = [''].concat(groep.waarden);
        alles.forEach(function (waarde) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'ks-map__chip';
          chip.textContent = waarde === '' ? 'Alle' : waarde;
          chip.setAttribute('aria-pressed', waarde === '' ? 'true' : 'false');
          chip.addEventListener('click', function () {
            self.actieveFilters[groep.sleutel] = waarde;
            Array.prototype.forEach.call(wrap.querySelectorAll('.ks-map__chip'), function (broer) {
              broer.setAttribute('aria-pressed', broer === chip ? 'true' : 'false');
            });
            self.sluitPopup();
            self.pasFiltersToe();
          });
          self.chips.push({ el: chip, sleutel: groep.sleutel, waarde: waarde });
          wrap.appendChild(chip);
        });

        self.filterBalk.appendChild(wrap);
      });

      this.filterBalk.hidden = false;
    }

    /**
     * Zoeken op postcode. De postcode gaat naar de PDOK Locatieserver (de publieke
     * adresdienst van de overheid), die de coordinaten teruggeeft; de afstand tot elk
     * verkooppunt rekenen we hier zelf uit. Geen app en geen sleutel.
     */
    bouwZoek() {
      this.zoekForm = this.querySelector('[data-search]');
      if (!this.zoekForm) return;

      var self = this;
      this.zoekInvoer = this.zoekForm.querySelector('[data-postcode]');
      this.zoekStraal = this.zoekForm.querySelector('[data-straal]');
      this.zoekNotitie = this.zoekForm.querySelector('[data-search-note]');
      this.zoekWis = this.zoekForm.querySelector('[data-search-reset]');
      this.zoekNotitieStandaard = this.zoekNotitie ? this.zoekNotitie.textContent : '';
      this.zoekForm.hidden = false;

      this.zoekInvoer.addEventListener('input', function () {
        var geldig = normaliseerPostcode(self.zoekInvoer.value) !== '';
        self.zoekStraal.disabled = !geldig;
        self.zoekInvoer.closest('.kh-field').removeAttribute('data-invalid');
        self.zoekInvoer.removeAttribute('aria-invalid');
        if (self.zoekNotitie) {
          self.zoekNotitie.textContent = geldig ? 'Kies een straal en zoek.' : self.zoekNotitieStandaard;
        }
      });

      this.zoekForm.addEventListener('submit', function (event) {
        event.preventDefault();
        self.zoekOpPostcode();
      });

      if (this.zoekWis) {
        this.zoekWis.addEventListener('click', function () {
          self.wisZoek();
          self.pasFiltersToe();
        });
      }
    }

    meldZoek(tekst, fout) {
      if (this.zoekNotitie) this.zoekNotitie.textContent = tekst;
      var veld = this.zoekInvoer && this.zoekInvoer.closest('.kh-field');
      if (veld) {
        if (fout) veld.setAttribute('data-invalid', '');
        else veld.removeAttribute('data-invalid');
      }
      if (this.zoekInvoer) {
        if (fout) this.zoekInvoer.setAttribute('aria-invalid', 'true');
        else this.zoekInvoer.removeAttribute('aria-invalid');
      }
    }

    zoekOpPostcode() {
      var self = this;
      var postcode = normaliseerPostcode(this.zoekInvoer.value);
      if (!postcode) {
        this.meldZoek('Dat is geen postcode. Gebruik vier cijfers en twee letters, bijvoorbeeld 8245 GH.', true);
        this.zoekInvoer.focus();
        return;
      }
      var straal = parseInt(this.zoekStraal.value, 10) || 5;
      this.meldZoek('Even zoeken...', false);

      var url =
        'https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?rows=1&fq=type:postcode&fl=centroide_ll&q=' +
        encodeURIComponent(postcode);

      fetch(url)
        .then(function (antwoord) {
          if (!antwoord.ok) throw new Error('status ' + antwoord.status);
          return antwoord.json();
        })
        .then(function (data) {
          var doc = data && data.response && data.response.docs && data.response.docs[0];
          var punt = doc && /POINT\(([-\d.]+) ([-\d.]+)\)/.exec(doc.centroide_ll || '');
          if (!punt) {
            self.meldZoek('We vonden deze postcode niet. Controleer de postcode en probeer het opnieuw.', true);
            return;
          }
          var lng = parseFloat(punt[1]);
          var lat = parseFloat(punt[2]);
          self.zoek = { lat: lat, lng: lng, straal: straal };
          self.rijen.forEach(function (rij) {
            var rlat = parseFloat(rij.dataset.lat);
            var rlng = parseFloat(rij.dataset.lng);
            rij.afstand = isNaN(rlat) || isNaN(rlng) ? undefined : afstandKm(lat, lng, rlat, rlng);
          });
          self.sorteerOpAfstand();
          self.sluitPopup();
          self.pasFiltersToe();
          if (self.zoekWis) self.zoekWis.hidden = false;
          var aantal = self.rijen.filter(function (r) { return !r.hidden; }).length;
          self.meldZoek(
            aantal === 0
              ? 'Geen verkooppunten binnen ' + straal + ' km van ' + postcode + '. Kies een grotere straal of bestel in de webshop.'
              : aantal + (aantal === 1 ? ' verkooppunt' : ' verkooppunten') + ' binnen ' + straal + ' km van ' + postcode + '.',
            false
          );
        })
        .catch(function () {
          self.meldZoek('Zoeken lukt nu niet. Probeer het later opnieuw, of bekijk de hele lijst hieronder.', true);
        });
    }

    sorteerOpAfstand() {
      var lijst = this.lijst;
      var gesorteerd = this.rijen.slice().sort(function (a, b) {
        var x = a.afstand === undefined ? Infinity : a.afstand;
        var y = b.afstand === undefined ? Infinity : b.afstand;
        return x - y;
      });
      gesorteerd.forEach(function (rij) {
        lijst.appendChild(rij);
        var label = rij.querySelector('.kh-store__dist');
        if (rij.afstand === undefined) {
          if (label) label.remove();
          return;
        }
        if (!label) {
          label = document.createElement('span');
          label.className = 'kh-store__dist';
          var route = rij.querySelector('a');
          rij.insertBefore(label, route);
        }
        label.textContent = rij.afstand < 10 ? rij.afstand.toFixed(1).replace('.', ',') + ' km' : Math.round(rij.afstand) + ' km';
      });
    }

    wisZoek() {
      this.zoek = null;
      if (!this.zoekForm) return;
      this.zoekInvoer.value = '';
      this.zoekStraal.disabled = true;
      this.meldZoek(this.zoekNotitieStandaard, false);
      if (this.zoekWis) this.zoekWis.hidden = true;
      this.rijen.forEach(function (rij) {
        rij.afstand = undefined;
        var label = rij.querySelector('.kh-store__dist');
        if (label) label.remove();
      });
    }

    pasFiltersToe() {
      var self = this;
      var zichtbaar = 0;

      this.rijen.forEach(function (rij) {
        var past =
          (!self.actieveFilters.provincie || rij.dataset.provincie === self.actieveFilters.provincie) &&
          (!self.actieveFilters.soort || rij.dataset.soort === self.actieveFilters.soort) &&
          (!self.zoek || (rij.afstand !== undefined && rij.afstand <= self.zoek.straal));

        rij.hidden = !past;
        if (rij.pinElement) rij.pinElement.hidden = !past;
        if (past) zichtbaar++;
      });

      if (this.teller) {
        this.teller.textContent =
          zichtbaar === 1 ? '1 verkooppunt' : zichtbaar + ' verkooppunten';
      }

      // De lege uitkomst: een uitleg en een knop om de filters te wissen.
      if (this.leeg) this.leeg.hidden = zichtbaar !== 0;

      // Een keuze die samen met de andere filter niets oplevert, is uitgeschakeld.
      this.chips.forEach(function (c) {
        if (c.waarde === '') {
          c.el.disabled = false;
          return;
        }
        var anders = c.sleutel === 'soort' ? 'provincie' : 'soort';
        var iets = self.rijen.some(function (rij) {
          return (
            rij.dataset[c.sleutel] === c.waarde &&
            (!self.actieveFilters[anders] || rij.dataset[anders] === self.actieveFilters[anders])
          );
        });
        c.el.disabled = !iets;
      });
    }
  }

  if (!customElements.get('knorshot-map')) {
    customElements.define('knorshot-map', KnorshotMap);
  }
})();
